import React from 'react'
import AuthComponent from '../../Components/AuthComponent/AuthComponent'

const LoginAdmin = () => {
  return (
    <AuthComponent rolComponent='admin' />
  )
}

export default LoginAdmin